import request from '../utils/request';

/**
 * 获取区域下的设备状态
 * @param locale
 * @param status
 * @param roomIds
 * @returns {Object}
 */
export const getDeviceTable = ({ locale, status, roomIds }) => {
  const url = `/monitor/getDeviceStatus/${status}?lang=${locale}`;
  return request(url, {
    method: 'POST',
    body: JSON.stringify(roomIds),
    headers: { 'Content-Type': 'application/json' }
  });
};

/**
 * 通过区域id获取区域下会议室id
 * @param locale
 * @param zoneId
 * @returns {Object}
 */
export const getRoomIds = ({ locale, zoneId }) => {
  const url = `/smartmeeting/smart/zone/getAllRoomByZoneId?lang=${locale}&zoneId=${zoneId}`;
  return request(url);
};

/**
 * 修复异常设备
 * @param locale
 * @param device
 * @returns {Object}
 */
export const controlDevice = ({ locale, device }) => {
  const url = `/action/deviceAction?lang=${locale}`;
  return request(url, {
    method: 'POST',
    body: JSON.stringify(device),
    headers: { 'Content-Type': 'application/json' }
  });
};

/**
 * 修复异常设备
 * @param locale
 * @param device
 * @returns {Object}
 */
export const repairDevice = ({ locale, device }) => {
  const url = `/action/deviceRepair?lang=${locale}`;
  return request(url, {
    method: 'POST',
    body: device.uniqueId,
    headers: { 'Content-Type': 'application/json' }
  });
};

/**
 * 删除已绑定设备
 * @param locale
 * @param device
 * @returns {Object}
 */
export const deleteDevice = ({ locale, device }) => {
  const url = `/monitor/unBindDevice?lang=${locale}`;
  return request(url, {
    method: 'POST',
    body: device.deviceId,
    headers: { 'Content-Type': 'application/json' }
  });
};

/**
 * 刷新全部设备
 * @param locale
 * @returns {Object}
 */
export const refreshAllDevice = ({ locale }) => {
  const url = `/smartmeeting/smart/board/refresh?lang=${locale}`;
  return request(url, { method: 'GET' });
};

/**
 * 获取告警设置
 * @param locale
 * @returns {Object}
 */
export const getAlarm = ({ locale }) => {
  const url = `/monitor/getAlarmConfig?lang=${locale}`;
  return request(url);
};

/**
 * 提交告警设置
 * @param locale
 * @param config
 * @returns {Object}
 */
export const setAlarm = ({ locale, config }) => {
  const url = `/monitor/alarmConfig?lang=${locale}`;
  return request(url, {
    method: 'POST',
    body: JSON.stringify(config),
    headers: { 'Content-Type': 'application/json' }
  });
};



// WEBPACK FOOTER //
// ./src/services/monitor.js